<template>
  <BaseDialog
    v-model="showDialog"
    :title="`Signatur ${fullName}`"
    maxWidth="800px"
    :width="null"
    @action="$emit('action')"
  >
    <template v-slot>
      <div class="backgroundColor">
        <v-img v-if="data" :src="data.dataUrl"></v-img>
      </div>
    </template>
  </BaseDialog>
</template>

<script lang="ts">
import Vue from "vue";

import BaseDialog from "@/components/shared/dialog/BaseDialog.vue";

export default Vue.extend({
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    data: {},
  },
  data() {
    return {
      title: "",
    };
  },
  computed: {
    showDialog: {
      get(): boolean {
        return this.value;
      },
      set(value: boolean) {
        this.$emit("input", value);
      },
    },
    fullName(): string {
      return this.data ? (this as any).data?.fullName : "";
    },
  },
  components: {
    BaseDialog,
  },
});
</script>

<style lang="scss" scoped>
.backgroundColor {
  background: var(--v-lightGrey-base) !important;
}
</style>
